import { isNil } from 'lodash';
import React from 'react';
import { formatDateTimeWithYear } from '@shared/util/date';
import { isDateComponent } from '../../utils';
import { WorkflowComponentProps } from './WorkflowComponent';
import { WorkflowTextComponent } from './WorkflowTextComponent';

type Datum = string | undefined;
type Data = Datum | Datum[];

/*
  TODO
  This component is only used as a readOnly lookup component.
  To use in forms, will need a date picker.
  See inputDate.
*/
export function WorkflowDateComponent({
  initialData,
  component,
  isReadOnly,
  showLabel,
  paddingHorizontal,
  iconPad,
  showIcon,
}: WorkflowComponentProps) {
  const displayString = formatData(initialData);
  const readOnly =
    isReadOnly || (component as MBAPI.WorkflowTemplate_components_DateComponent).readonly;

  if (!isDateComponent(component)) {
    return null;
  }

  if (readOnly) {
    return (
      <WorkflowTextComponent
        initialData={displayString}
        component={component}
        isReadOnly
        showLabel={showLabel}
        paddingHorizontal={paddingHorizontal}
        iconPad={iconPad}
        showIcon={showIcon}
      />
    );
  }

  return null;
}

function formatData(data: Data): string | null {
  if (isNil(data)) {
    return null;
  }

  if (Array.isArray(data)) {
    const displayableData = data.filter((d): d is string => !isNil(d));
    return displayableData.length > 0
      ? displayableData.map(formatDateTimeWithYear).join(', ')
      : null;
  }

  return data;
}
